module.exports = __webpack_public_path__ + "static/media/fin-logo.a0d2d83a.svg";